import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=4bd299a6&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=4bd299a6&prod&lang=scss"
import style1 from "./layout.vue?vue&type=style&index=1&id=4bd299a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd299a6",
  null
  
)

export default component.exports